<template>
    <div>
        <v-textarea
            v-model="textList"
            rows="8"
            label="Attendee Text List"
        />

        <v-data-table
        :headers="headers"
        :items="parsed"
        :hide-default-footer="true"
        />
        <v-card-actions>
                <v-checkbox
                        v-model="replaceExisting"
                    label="Replace existing"
                />
                <v-spacer/>
                <v-btn @click="updateList" color="success" dark>
                    <v-icon>mdi-file</v-icon>
                    Import
                </v-btn>
        </v-card-actions>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object
            },
        },
        data() {
            return {
                textList: '',
                replaceExisting: false,
                headers: [
                    { text: 'First Name', value: 'firstName' },
                    { text: 'Last Name', value: 'lastName' },
                    { text: 'Email', value: 'email' },
                ],
            }
        },
        computed: {
            parsed() {
                let lines = this.textList.split("\n");
                let data = []

                lines.forEach((text) => {

                    if(text === '') {
                        return
                    }
                    let cols = text.split(' ')
                    let row = {}

                    if(cols[0]){
                        row.firstName = cols[0]
                    }

                    if(cols[1]){
                        row.lastName = cols[1]
                    }

                    if(cols[2]){
                        row.email = cols[2]
                    }

                    data.push(row);
                })
                return data;
            }
        },
        methods: {
            updateList() {
                this.parsed.forEach((row, parsedIndex) => {
                    if(this.replaceExisting){
                        this.$_.assign(this.value.attendees[parsedIndex], row )
                    }else{
                        let lastAvailableIndex = null
                        let assigned = false
                        this.value.attendees.forEach((attendee, index) => {
                            if(assigned || (lastAvailableIndex !== null && index < lastAvailableIndex)){
                                return
                            }
                            if(attendee.firstName === null && (attendee.lastName === '' || attendee.lastName === 'TBA')){
                                this.$_.assign(this.value.attendees[index], row )
                                lastAvailableIndex = index
                                assigned = true
                            }
                        })

                    }

                })
                this.$emit('complete')
            }
        },
    }
</script>

<style scoped>

</style>